import { GridPaginationModel } from '@mui/x-data-grid';
import { Dayjs } from 'dayjs';

type ActionDetail = {
    filename: string;
    download_link: string;
    m2comm_key: string;
    status: string;
    timestamp: number;
    inserted: Record<string, number>;
    updated: Record<string, number>;
    unchanged: Record<string, number>;
    duplicated: Record<string, number>;
    default_message: string;
};
export interface HistoryRecord {
    history_id: number;
    store_id: number;
    user_id: number | null;
    user_name: string | null;
    action_type: string;
    action_detail: ActionDetail;
    ip_address: string;
    device_info: string;
    created_at: string;
    updated_at: string;
}
export interface StoreHistoryListResponse {
    aaData: HistoryRecord[];
    draw: number;
    display_request: number;
    total_records: number;
    max_page: number;
    explanation: string;
}

export interface HistoryListRequestData {
    store_id: number;
    action_type: string;
    start_time: string | null;
    end_time: string | null;
    keyword: string;
    current_page: number;
    data_per_page: number;
}

export interface HistorySearchQuery {
    start_time: Dayjs | null;
    end_time: Dayjs | null;
    keyword: string | null;
    action_type: string | null;
}

interface SortModelType {
    field: string | null;
    sort: 'asc' | 'desc' | null;
}
type RfuInfo = {
    current_max_hex: string;
    device_type: string;
    new_id: string;
    new_ver_hex: string;
};

export type RfuSummary = {
    max_by_device: {
        [key: number]: string;
    };
    no_upgrades: RfuInfo[];
    upgrades: RfuInfo[];
    mode: string;
    targetsByFw: {
        'DEV.RFU_ARE': Record<string, string[]>;
        'DEV.RFU_GW': Record<string, string[]>;
    };
    mac_count: number;
};

export type PpSummary = {
    product_length: number;
    success_synced: number;
    failed_synced: number;
    barcodes: {
        success: string[];
        failed: string[];
        unchanged: string[];
        blocked: {
            barcode: string;
            reason: string;
        }[];
    };
    inserted: number;
    updated: number;
    unchanged: number;
    blocked: number;
    pushed_tags: string[];
    pushed_tags_count: number;
};
export type SummaryInfo = PpSummary | RfuSummary;
export interface StoreHistoryPageState {
    tableLoading: boolean;
    searchQuery: HistorySearchQuery;
    historyList: HistoryRecord[];
    paginationModel: GridPaginationModel;
    rowCount: number;
    sortModel: SortModelType;
    openSummaryDialog: boolean;
    summaryInfo: SummaryInfo;
    jobId: string | null;
}

export type StoreHistoryPageAction =
    | { type: 'SET_TABLE_LOADING'; payload: boolean }
    | { type: 'SET_SEARCH_QUERY'; payload: HistorySearchQuery }
    | { type: 'CLEAR_HISTORY_FILTERS'; payload: HistorySearchQuery }
    | { type: 'SET_PAGINATION_MODEL'; payload: GridPaginationModel }
    | { type: 'SET_HISTORY_TABLE'; payload: StoreHistoryListResponse }
    | { type: 'SET_SORT_MODEL'; payload: SortModelType }
    | { type: 'SET_SUMMARY_DIALOG_OPEN'; payload: boolean }
    | { type: 'SET_SUMMARY_INFO'; payload: SummaryInfo }
    | { type: 'SET_JOB_ID'; payload: string }
    | { type: 'CLEAR_FILTER'; payload: { start_time: Dayjs | null; end_time: Dayjs | null } };

export enum HISTORY_TYPE {
    AP = 'ap_history',
    PP = 'pp_history',
    RFU = 'rfu_history',
    API = 'api_history',
}
export type HistoryType = HISTORY_TYPE.AP | HISTORY_TYPE.PP | HISTORY_TYPE.RFU | HISTORY_TYPE.API;
export const SUMMARY_TITLE: Partial<Record<HistoryType, string>> = {
    [HISTORY_TYPE.PP]: 'Incoming Products Summary',
    [HISTORY_TYPE.RFU]: 'Auto RFU Summary',
};
export type SummaryDialogProps = {
    open: boolean;
    type: HistoryType;
    onClose: () => void;
    onExited: () => void;
    summaryInfo?: SummaryInfo;
    jobId?: string | null;
};

export type PpSummaryRequestData = {
    store_id: number;
    job_id: string;
};
